import classnames from 'classnames';
import React from 'react';
import { Icon } from '../Icon';
export const SportIcon = ({ sport, className }) => {
    switch (sport === null || sport === void 0 ? void 0 : sport.toLocaleLowerCase()) {
        case 'soccer':
        case 'football':
            return React.createElement(Icon, { icon: "soccer", iconSize: "large", className: classnames('sportIcon', className) });
        case 'rugby league':
            return React.createElement(Icon, { icon: "rugbyLeague", iconSize: "large", className: classnames('sportIcon', className) });
        case 'rugby union':
            return React.createElement(Icon, { icon: "rugbyUnion", iconSize: "large", className: classnames('sportIcon', className) });
        default:
            return React.createElement("div", { className: classnames(`missing sport`, className) });
    }
};
//# sourceMappingURL=index.js.map